import { _, React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type RiskModelPercentSignificanceProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: Params) => void;
  title: string;

  fullScreen?: boolean;
  context?: ts.types.riskModel.RiskModelAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'risk_model_percent_significance', string>;
};

const RiskModelPercentSignificance = ({
  id,
  readOnly,
  widgetKey,
  mode,
  params,
  setParams,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  context,
  title,
}: RiskModelPercentSignificanceProps) => {
  const renderJobComponent = () => (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['risk_model_percent_significance']}
      fullScreen={fullScreen}
      factors={params.risk_factors.map((f) => f.value)}
      title={title}
    />
  );

  return (
    <>
      {mode == 'edit' ? (
        <Form params={params} setParams={setParams} context={context} noContext={_.isEmpty(context)} />
      ) : (
        renderJobComponent()
      )}
    </>
  );
};

export default RiskModelPercentSignificance;
